import { render, staticRenderFns } from "./Deliverables.vue?vue&type=template&id=a3aae634&"
import script from "./Deliverables.vue?vue&type=script&lang=js&"
export * from "./Deliverables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports